import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { BuildBrowseComponent } from './browse/browse.component';
import { BuildDetailComponent } from './detail/detail.component';
import { ProjectHeaderComponent } from '../../core/modules/project/projectHeader/project.header.component';

import { BuildResolvesService } from './build-resolves.service';
import { TourService } from '../../core/modules/tour/tour.service';
import { BuildService } from './build.service';
import { ProjectModel } from '../../core/services/project.model.service';

export const BUILD_STATES: any[] = [
    {
        name: 'home.project.summary.builds',
        //URL:/project/PROJECT_UNIXNAME/builds
        url: '/builds?page_num&page_size&sort_field&sort_dir&job&jobDescription&description&changelog&buildNumber&wasSuccessful',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            job: {
                value: '',
                squash: true
            },
            jobDescription: {
                value: '',
                squash: true
            },
            description: {
                value: '',
                squash: true
            },
            changelog: {
                value: '',
                squash: true
            },
            buildNumber: {
                value: '',
                squash: true
            },
            wasSuccessful: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'security',
                deps: ['project', ProjectModel],
                resolveFn: async (project: any, projectModel: ProjectModel) => {
                    return BuildResolvesService.security(project, projectModel);
                }
            },
            {
                token: 'tour',
                deps: ['$transition$', TourService],
                resolveFn: async (transition: any, tourService: any) => {
                    return BuildResolvesService.buildsTour(tourService, transition);
                }
            }
        ],
        views: {
            //project.main.html, 'projectheader' ui-view disabled.
            //"add" and "edit" inherit, show it disabled too.
            'contentarea@home.project.summary': {
                component: BuildBrowseComponent
            }
        }
    },
    {
        name: 'home.project.summary.builds.detail',
        //URL:/project/PROJECT_UNIXNAME/builds/ID
        url: '/:id',
        resolve: [
            {
                token: 'security',
                deps: ['project', ProjectModel],
                resolveFn: async (project: any, projectModel: ProjectModel) => {
                    return BuildResolvesService.security(project, projectModel);
                }
            },
            {
                token: 'build',
                deps: ['$transition$', BuildService],
                resolveFn: async ($transition$: any, buildService: any) => {
                    return BuildResolvesService.getBuild(buildService, $transition$.params());
                }
            },
            {
                token: 'tour',
                deps: [TourService],
                resolveFn: async (tourService: any) => {
                    return BuildResolvesService.buildDetailTour(tourService);
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: BuildDetailComponent
            }
        }
    }
];